import { EMPTY_STRING } from '../../../../constants/common'

import {
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EPOST,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_COMPOSITE_MASS_ACTION,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EPOST,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EPOST,
  DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE,
} from './DocFlowSendingCommunicationTable.constants'

export function getDocFlowSendingResultDeleteAttentionModalText(action) {
  switch (action) {
    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE:
      return 'DocumentStapling.MapingResultMassDeleteAllUsersAttentionTextKey'

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE:
      return 'DocumentStapling.MapingResultItemDeleteLastUserAttentionTextKey'

    default:
      return null
  }
}

export function getDocFlowSendingResultNotificationTitle({
  action,
  count,
  t,
  totalCount,
}) {
  const types = {
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE]: t(
      'Notification.CommonTitleDeletedKey'
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SAVE_TO_PROFILE]: t(
      'Notification.CommonTitleToggledKey'
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_ADDITIONAL_EMAIL]: t(
      'Notification.CommonTitleToggledKey'
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EMAIL]: t(
      'Notification.CommonTitleToggledKey'
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_SEND_EPOST]: t(
      'Notification.DocFlowSendEpostKey'
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_COMPOSITE_MASS_ACTION]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE]:
      t('Notification.CommonTitleMassSavedKey', {
        count,
        totalCount,
      }),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL]:
      t('Notification.CommonTitleMassSavedKey', {
        count,
        totalCount,
      }),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EPOST]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE]:
      t('Notification.CommonTitleMassSavedKey', {
        count,
        totalCount,
      }),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL]:
      t('Notification.CommonTitleMassSavedKey', {
        count,
        totalCount,
      }),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EPOST]: t(
      'Notification.CommonTitleMassSavedKey',
      {
        count,
        totalCount,
      }
    ),
    [DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE]: t(
      'Notification.CommonTitleMassDeletedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getSendingCommunicationTableItemActions({ permissions }) {
  return [
    ...(permissions.can_delete
      ? [
          {
            label: 'DocumentStapling.SendingTableDeleteActionOptionKey',
            permission: permissions.can_delete,
            value: DOC_FLOW_SENDING_COMMUNICATION_TABLE_ACTION_DELETE,
          },
        ]
      : []),
  ]
}

export function getSendingCommunicationTableMassActions(t) {
  return [
    {
      label: t('DocumentStaplingTable.DeleteActionOptionKey'),
      value: DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE,
    },
    {
      label: t('DocFlow.SendingPhaseActivateSaveToProfileOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE,
    },
    {
      label: t('DocFlow.SendingPhaseDeactivateSaveToProfileOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE,
    },
    {
      label: t('DocFlow.SendingPhaseActivateSendEmailOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL,
    },
    {
      label: t('DocFlow.SendingPhaseDeactivateSendEmailOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL,
    },
    {
      label: t('DocFlow.SendingPhaseActivateSendAdditionalEmailOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL,
    },
    {
      label: t('DocFlow.SendingPhaseDeactivateSendAdditionalEmailOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL,
    },
    {
      label: t('DocFlow.SendingPhaseActivateSendEpostOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EPOST,
    },
    {
      label: t('DocFlow.SendingPhaseDeactivateSendEpostOptionKey'),
      value:
        DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EPOST,
    },
  ]
}

export function getSendingCommunicationTableFilterApi(id) {
  return `/api/document-stapling/document-staplings/${id}/sending-files/single-field/`
}

export function getSendingCommunicationTableMassConfirmationText(action, t) {
  switch (action) {
    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SAVE_TO_PROFILE:
      return t('DocFlow.ActivateSaveToProfileConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SAVE_TO_PROFILE:
      return t('DocFlow.DeactivateSaveToProfileConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EMAIL:
      return t('DocFlow.ActivateSendEmailConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EMAIL:
      return t('DocFlow.DeactivateSendEmailConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_ADDITIONAL_EMAIL:
      return t('DocFlow.ActivateSendAdditionalEmailConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_ADDITIONAL_EMAIL:
      return t('DocFlow.DeactivateSendAdditionalEmailConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_ACTIVATE_SEND_EPOST:
      return t('DocFlow.ActivateSendEpostConfirmationModalTextKey')

    case DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DEACTIVATE_SEND_EPOST:
      return t('DocFlow.DeactivateSendEpostConfirmationModalTextKey')

    default:
      return EMPTY_STRING
  }
}
